import React, { memo, forwardRef, useState, useEffect } from 'react';

import Editor from '@components/richEditor/richEditor';
import { RICH_TYPE } from '@components/richEditor/configs';

const getContentSource = (value) => {
  if (typeof value === 'object') {
    return value;
  }
  try {
    const res = JSON.parse(value);
    if (Object.keys(res).includes('blocks')) {
      return res;
    }
    return {
      blocks: [
        {
          key: '1lmj9',
          text: value || '',
          type: 'unstyled',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
  } catch {
    return {
      blocks: [
        {
          key: '1lmj9',
          text: value || '',
          type: 'unstyled',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
  }
};
function RichEditor(
  {
    value,
    onClick,
    typeField = {
      underline: true,
      italic: true,
      bold: true,
      unordered_list: true,
      ordered_list: true,
      link: true,
      text_color: true,
    },
    ...restProps
  },
  ref,
) {
  const [count, setCount] = useState(0); // solve with the bug temporarily

  useEffect(() => {
    setCount(count + 1);
  }, [value]);

  if (value === undefined && count === 0) {
    return null;
  }

  return (
    <div onClick={onClick} className="rich-text-editor-wrapper">
      <Editor
        ref={ref}
        contentSource={getContentSource(value)}
        richTypes={[
          typeField.underline && RICH_TYPE.UNDERLINE,
          typeField.italic && RICH_TYPE.ITALIC,
          typeField.bold && RICH_TYPE.BOLD,
          typeField.unordered_list && RICH_TYPE.UNORDERED_LIST,
          typeField.ordered_list && RICH_TYPE.ORDERED_LIST,
          typeField.link && RICH_TYPE.LINK,
          typeField.text_color && RICH_TYPE.TEXT_COLOR,
        ]}
        {...restProps}
      />
    </div>
  );
}

RichEditor.propTypes = {};

export default memo(forwardRef(RichEditor));
